module.exports = __webpack_public_path__ + "static/media/Flagpole_black.687c0493.svg";